import {
  ADD_TOASTER,
  ADD_TOASTER_TIMEOUT,
  ADD_TOOLTIP,
  DEACTIVATE_TOASTER,
  REMOVE_TOASTER,
  ToasterAction,
  ToasterMessage,
  ToasterObject
} from './types';

export const addToaster = (toaster: ToasterMessage): ToasterAction => ({
  type: ADD_TOASTER,
  payload: {
    toaster
  }
});

export const addTooltip = (toaster: ToasterMessage): ToasterAction => ({
  type: ADD_TOOLTIP,
  payload: {
    toaster
  }
});

export const addTimeout = (toaster: ToasterObject): ToasterAction => ({
  type: ADD_TOASTER_TIMEOUT,
  payload: {
    toaster
  }
});

export const removeToaster = (id: number): ToasterAction => ({
  type: REMOVE_TOASTER,
  payload: {
    id,
  }
});

export const deactivateToaster = (id: number): ToasterAction => ({
  type: DEACTIVATE_TOASTER,
  payload: {
    id,
  }
});
